<mat-dialog-content>
    Are you sure you want to cancel?
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Yes</button>
    <button mat-button [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>
